import { TaxiCorporationFleetPartnerListItem } from "../../../../../common/services/taxi-corporation/fleet-partner/list/taxi-corporation-fleet-partner-list";
import TaxiFleetPartnerListingItem from "./types/taxi-fleet-partner-listing-item";

const createListingItem = (
  taxiFleetPartnerListItem: TaxiCorporationFleetPartnerListItem,
): TaxiFleetPartnerListingItem => {
  return {
    uuid: taxiFleetPartnerListItem.uuid,
    name: taxiFleetPartnerListItem.name,
    creationDate: taxiFleetPartnerListItem.creationDate,
    notes: taxiFleetPartnerListItem.notes,
  };
};

const createListingItems = (
  responseDataItems: TaxiCorporationFleetPartnerListItem[],
): TaxiFleetPartnerListingItem[] => {
  return responseDataItems.map(createListingItem);
};

const taxiFleetPartnerListingItemFactory = {
  createListingItems,
};

export default taxiFleetPartnerListingItemFactory;
